<script setup lang="ts">
import { useCarousel } from './useCarousel'
import { cn } from '../../../lib/utils'
import { Button } from '../button'
import StepCounterArrow from "../../../icons/StepCounterArrow.vue";

const props = defineProps<{
  ariaLabel?: string;
}>()

const { orientation, canScrollPrev, scrollPrev } = useCarousel()
</script>

<template>
  <Button
    :disabled="!canScrollPrev"
    :class="cn(
      orientation === 'horizontal' ? '' : 'rotate-90',
      { 'opacity-30': !canScrollPrev }
    )"
    variant="icon"
    :aria-label="props.ariaLabel ?? 'Previous slide'"
    @click="scrollPrev"
  >
    <slot>
      <StepCounterArrow class="h-32 w-32 rotate-180" />
    </slot>
  </Button>
</template>
